import { useSearchParams } from "react-router-dom";
import { useGetPurchaseOrderQuery } from "../../features/po/poSlice";
import Loading from "../../components/Loading";
import PurchaseOrderForm from "./PurchaseOrderForm";

const PurchaseOrderSwitcher = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    // figure out if the draft order is accompanied by an actual order, and if so, grab status info
    const {data: order, error, isLoading } = useGetPurchaseOrderQuery(searchParams.get("draft_id"));
    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <PurchaseOrderForm />;
    }
    if ("error" in order) {
        return <PurchaseOrderForm />;
    }
    return <PurchaseOrderForm orderStatusInfo={order} readOnly={!(order.status === "draft" || order.internal_status === "")}/>;
}

export default PurchaseOrderSwitcher;
